// src/pages/LoginPage.js
// หน้าเข้าสู่ระบบ (ธีมซาลอนขาว-เทา-ชมพู เข้ากับ POS88)

import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api";
import AuthContext from "../AuthContext";

const LoginPage = () => {
  const { setUser, setToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // path ที่ผู้ใช้พยายามเข้า ก่อนถูกเด้งมาหน้า login
  const redirectPath =
    location.state?.from && typeof location.state.from === "string"
      ? location.state.from
      : "/dashboard";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("กรุณากรอกชื่อผู้ใช้และรหัสผ่าน");
      return;
    }

    try {
      setLoading(true);
      const res = await api.post("/auth/login", {
        username,
        password,
      });

      const { access_token, user } = res.data;

      if (!access_token || !user) {
        setError("รูปแบบข้อมูลจากเซิร์ฟเวอร์ไม่ถูกต้อง");
        return;
      }

      // เก็บลง context (AuthProvider จะ sync ไป localStorage ให้เอง)
      setToken(access_token);
      setUser(user);

      // ไป path เดิม หรือ dashboard
      navigate(redirectPath, { replace: true });
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        "เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบชื่อผู้ใช้ / รหัสผ่าน";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes slideUp {
            from { transform: translateY(30px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
          @keyframes shimmer {
            0% { background-position: -1000px 0; }
            100% { background-position: 1000px 0; }
          }
          .luxury-input::placeholder {
            color: rgba(212, 175, 55, 0.4) !important;
          }
          .luxury-scroll::-webkit-scrollbar {
            width: 6px;
          }
          .luxury-scroll::-webkit-scrollbar-track {
            background: #1a1a1a;
          }
          .luxury-scroll::-webkit-scrollbar-thumb {
            background: #d4af37;
            border-radius: 3px;
          }
        `}
      </style>

      {/* 1. Background - Deep Luxury Dark */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "radial-gradient(circle at center, #2c3e50 0%, #000000 100%)",
          zIndex: -1,
        }}
      >
        {/* Decorative Elements */}
        <div style={{
          position: "absolute",
          top: "10%",
          left: "10%",
          width: "300px",
          height: "300px",
          background: "radial-gradient(circle, rgba(212, 175, 55, 0.15) 0%, rgba(0,0,0,0) 70%)",
          filter: "blur(40px)",
          animation: "fadeIn 3s ease-in-out"
        }} />
        <div style={{
          position: "absolute",
          bottom: "10%",
          right: "10%",
          width: "400px",
          height: "400px",
          background: "radial-gradient(circle, rgba(212, 175, 55, 0.1) 0%, rgba(0,0,0,0) 70%)",
          filter: "blur(60px)",
          animation: "fadeIn 4s ease-in-out"
        }} />
      </div>

      {/* 2. Content Container */}
      <div className="container h-100">
        <div
          className="row justify-content-center align-items-center h-100"
          style={{ minHeight: "100vh" }}
        >
          {/* Main Card */}
          <div className="col-lg-10">
            <div
              className="row g-0 shadow-lg"
              style={{
                borderRadius: "20px",
                overflow: "hidden",
                border: "1px solid rgba(212, 175, 55, 0.3)",
                boxShadow: "0 0 40px rgba(212, 175, 55, 0.15)",
                animation: "slideUp 0.8s ease-out",
                background: "rgba(10, 10, 10, 0.8)",
                backdropFilter: "blur(20px)",
              }}
            >
              {/* Left Side - Brand & Info (Hidden on mobile) */}
              <div
                className="col-lg-6 d-none d-lg-flex flex-column justify-content-center p-5 position-relative"
                style={{
                  background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
                  borderRight: "1px solid rgba(212, 175, 55, 0.2)"
                }}
              >
                {/* Decorative Pattern Overlay */}
                <div style={{
                  position: "absolute",
                  top: 0, left: 0, right: 0, bottom: 0,
                  backgroundImage: "radial-gradient(rgba(212, 175, 55, 0.1) 1px, transparent 1px)",
                  backgroundSize: "30px 30px",
                  opacity: 0.3,
                  pointerEvents: "none"
                }} />

                <div style={{ position: "relative", zIndex: 1 }}>
                  <div className="mb-4">
                    <span style={{
                      color: "#d4af37",
                      fontSize: "0.9rem",
                      letterSpacing: "3px",
                      textTransform: "uppercase",
                      fontWeight: 600
                    }}>
                      Premium Management System
                    </span>
                    <h1 style={{
                      fontSize: "4rem",
                      fontWeight: 800,
                      background: "linear-gradient(45deg, #d4af37, #fceabb, #d4af37)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
                      margin: "10px 0"
                    }}>
                      POS88
                    </h1>
                    <div style={{
                      width: "80px",
                      height: "4px",
                      background: "linear-gradient(90deg, #d4af37, transparent)",
                      marginBottom: "2rem"
                    }} />
                  </div>

                  <p style={{ color: "#94a3b8", fontSize: "1.1rem", lineHeight: 1.8, marginBottom: "3rem" }}>
                    ยกระดับธุรกิจของคุณสู่ความสำเร็จ<br />
                    ด้วยระบบจัดการร้านที่เหนือระดับ<br />
                    <span style={{ color: "#d4af37" }}>หรูหรา • ทันสมัย • มั่งคั่ง</span>
                  </p>

                  <div className="d-flex gap-4">
                    <div style={{ textAlign: "center" }}>
                      <div style={{
                        color: "#d4af37",
                        fontSize: "1.5rem",
                        fontWeight: 700,
                        marginBottom: "0.2rem"
                      }}>100%</div>
                      <div style={{ color: "#64748b", fontSize: "0.8rem" }}>Secure</div>
                    </div>
                    <div style={{ width: "1px", background: "rgba(255,255,255,0.1)" }} />
                    <div style={{ textAlign: "center" }}>
                      <div style={{
                        color: "#d4af37",
                        fontSize: "1.5rem",
                        fontWeight: 700,
                        marginBottom: "0.2rem"
                      }}>24/7</div>
                      <div style={{ color: "#64748b", fontSize: "0.8rem" }}>Support</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side - Login Form */}
              <div className="col-lg-6 p-5" style={{ position: "relative" }}>
                <div className="d-flex align-items-center justify-content-between mb-5">
                  <h2 style={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "2rem",
                    margin: 0
                  }}>
                    เข้าสู่ระบบ
                  </h2>
                  <div style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(212, 175, 55, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#d4af37"
                  }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8m0-4l4-4m0 0l-4-4m4 4H9"></path>
                    </svg>
                  </div>
                </div>

                {error && (
                  <div className="alert" style={{
                    background: "rgba(239, 68, 68, 0.1)",
                    border: "1px solid rgba(239, 68, 68, 0.3)",
                    color: "#fca5a5",
                    borderRadius: "10px",
                    fontSize: "0.9rem"
                  }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: "8px" }}>
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label style={{ color: "#94a3b8", fontSize: "0.9rem", marginBottom: "8px", display: "block" }}>
                      ชื่อผู้ใช้
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        className="form-control luxury-input"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Username"
                        style={{
                          background: "rgba(255, 255, 255, 0.05)",
                          border: "1px solid rgba(255, 255, 255, 0.1)",
                          color: "#fff",
                          padding: "12px 15px 12px 45px",
                          borderRadius: "10px",
                          fontSize: "1rem",
                          transition: "all 0.3s ease"
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#d4af37";
                          e.target.style.boxShadow = "0 0 0 2px rgba(212, 175, 55, 0.2)";
                          e.target.style.background = "rgba(255, 255, 255, 0.08)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "rgba(255, 255, 255, 0.1)";
                          e.target.style.boxShadow = "none";
                          e.target.style.background = "rgba(255, 255, 255, 0.05)";
                        }}
                      />
                      <svg
                        width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="2"
                        style={{ position: "absolute", left: "15px", top: "50%", transform: "translateY(-50%)", opacity: 0.8 }}
                      >
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </svg>
                    </div>
                  </div>

                  <div className="mb-5">
                    <label style={{ color: "#94a3b8", fontSize: "0.9rem", marginBottom: "8px", display: "block" }}>
                      รหัสผ่าน
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        type="password"
                        className="form-control luxury-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        style={{
                          background: "rgba(255, 255, 255, 0.05)",
                          border: "1px solid rgba(255, 255, 255, 0.1)",
                          color: "#fff",
                          padding: "12px 15px 12px 45px",
                          borderRadius: "10px",
                          fontSize: "1rem",
                          transition: "all 0.3s ease"
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#d4af37";
                          e.target.style.boxShadow = "0 0 0 2px rgba(212, 175, 55, 0.2)";
                          e.target.style.background = "rgba(255, 255, 255, 0.08)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "rgba(255, 255, 255, 0.1)";
                          e.target.style.boxShadow = "none";
                          e.target.style.background = "rgba(255, 255, 255, 0.05)";
                        }}
                      />
                      <svg
                        width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="2"
                        style={{ position: "absolute", left: "15px", top: "50%", transform: "translateY(-50%)", opacity: 0.8 }}
                      >
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      width: "100%",
                      padding: "14px",
                      background: "linear-gradient(135deg, #d4af37 0%, #c5a028 100%)",
                      border: "none",
                      borderRadius: "10px",
                      color: "#1e293b",
                      fontWeight: 700,
                      fontSize: "1rem",
                      letterSpacing: "0.5px",
                      cursor: loading ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 15px rgba(212, 175, 55, 0.3)",
                      position: "relative",
                      overflow: "hidden"
                    }}
                    onMouseEnter={(e) => {
                      if (!loading) {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 8px 25px rgba(212, 175, 55, 0.4)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!loading) {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px 15px rgba(212, 175, 55, 0.3)";
                      }
                    }}
                  >
                    {loading ? (
                      <span className="d-flex align-items-center justify-content-center">
                        <svg className="animate-spin" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: "8px", animation: "spin 1s linear infinite" }}>
                          <circle cx="12" cy="12" r="10" opacity="0.25"></circle>
                          <path d="M12 2v3m4.22 1.78l2.12-2.12m5 5h-3m-1.78 4.22l2.12 2.12m-5 5v-3m-4.22-1.78l-2.12 2.12m-5-5h3m1.78-4.22l-2.12-2.12" opacity="0.75"></path>
                        </svg>
                        Authenticating...
                      </span>
                    ) : (
                      "เข้าสู่ระบบ"
                    )}
                  </button>
                </form>

                <div className="mt-4 text-center">
                  <small style={{ color: "#64748b" }}>
                    © {new Date().getFullYear()} POS88 Luxury System
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;